import React, { useContext, useEffect, useRef } from 'react';
import {
  type RestMultiRowSurveyCard,
  type SurveyType,
} from '@bbkAdminUtils/api-client/rest-cards-types';
import { type RestFortySixtyMiniModal4Modal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import { findSelectedReason } from '@bbkFunnelUtils/reason-other';
import { RefsContext } from '@bbkFunnelUtils/refs.context';
import { DeleteTextField } from '../survey/delete-textfield';
import DataReasons from './sections/data-reasons';
import HelpText from './sections/help-text';
import ModalPerson from './sections/person';
import SimpleModalTitle from './sections/simple-title';

const circle = (
  <svg height="18" width="18" style={{ marginTop: '3px' }}>
    <circle cx="9" cy="9" r="2" fill="#5e5e5e" />
  </svg>
);

type Props = Pick<
  RestFortySixtyMiniModal4Modal['requires'],
  'info' | 'person'
> & {
  surveyType: SurveyType | '';
  questions: RestMultiRowSurveyCard['requires']['multi_row_survey'];
  response: Partial<RestMultiRowSurveyCard['provides']>;
  handleAction: CallableFunction;
};

const NoteModal4: React.FC<Props> = (props) => {
  const { info, person, surveyType, response, questions, handleAction } = props;

  const refsPrefix = '123'; // FIXME
  const refsContext = useContext(RefsContext);
  const titleRef = useRef<HTMLSpanElement>(null);
  useEffect(() => refsContext?.addRef(`${refsPrefix}`, titleRef), [titleRef]);

  const importantList = (
    <>
      {info.important.map((i) => (
        <div className="d-flex align-items-start" key={i}>
          {circle}
          {i}
        </div>
      ))}
    </>
  );

  const selectedReason = findSelectedReason(surveyType, response, questions);
  return (
    <div className="forty-sixty-mini-modal-3 forty-sixty-mini-modal">
      <div className="MMContainer">
        <div className="left">{person && <ModalPerson person={person} />}</div>
        <div className="right">
          <div className="wrap">
            <div className="reasons mb-3 mb-md-5 d-md-flex">
              <DataReasons
                reasons={info.account_data}
                reason={selectedReason}
              />
            </div>
            <SimpleModalTitle>
              <span ref={titleRef}>
                <CustomerHtml value={info.title} />
              </span>
            </SimpleModalTitle>
            <div className="note">
              <div className="details">
                <CustomerHtml value={info.details} />
              </div>
            </div>
            <div className="mt-3 mb-3">
              <HelpText
                cta={
                  info.cta ??
                  'Please type %s in the box below to close your account'
                }
                phrase={info.phrase ?? 'DELETE'}
              />
              <DeleteTextField
                placeholder={info.placeholder ?? 'Start typing...'}
                valueToType={info.phrase ?? 'DELETE'}
                handleSubmit={handleAction}
              />
            </div>
            <div className="importants tw-mt-4">
              <div className="bold">{info.importantTitle || 'Important:'}</div>
              {importantList}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteModal4;
